<template>
  <div class="backoffice-not-allowed">
    <img :src="require('@/assets/backoffice-not-allowed.svg')" />

    <div>
      <h1>Não foi dessa vez</h1>
      <h2 class="mb-4">Sua integração com a plataforma CBM não permite realizar essa ação.</h2>
      <p class="mb-0">
        Apenas <b>integrações via frente de caixa</b> permitem que a Mercafacil gerencie as ofertas do seu clube de descontos. Verifique com seu consultor qual
        a sua melhor opção de integração.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BackofficeNotAllowed',
}
</script>

<style lang="scss" scoped>
.backoffice-not-allowed {
  margin-top: 72px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 90px;

  > div {
    max-width: 550px;
  }
}

h1 {
  font-size: 56px;
  color: $cinza-d10;
  line-height: 1.1;
}

h2 {
  font-size: 22px;
  color: $cinza-d10;
}

p {
  font-size: 16px;
  line-height: 24px;
  color: $cinza-0;

  b {
    color: $marca-1;
  }
}
</style>
